import { useQuery } from '@tanstack/react-query';

import getSampling from '../api/getSampling';

export const useSampling = (productId: string, id: string) => {
  const query = useQuery({
    queryKey: ['sampling', id],
    queryFn: async () => {
      const response = await getSampling(productId, id);

      return response.data;
    },
    enabled: !!id
  });

  return query;
};
